import { Injectable } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { CartActions } from '@spartacus/cart/base/core';
import { AuthStatePersistenceService, createFrom, EventService } from '@spartacus/core';
import { ActionsSubject } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Ga4GgCartAddEntrySuccessEvent } from './ga4-gg-cart-add-entry-success-event';

@Injectable({
  providedIn: 'root',
})
export class Ga4GgCartAddEntrySuccessEventBuilder {
  constructor(
    private eventService: EventService,
    private actionsSubject: ActionsSubject,
    private authStatePersistenceService: AuthStatePersistenceService
  ) {
    const ga4GgCartAddEntrySuccessCleanUpEventSource = this.getAction(CartActions.CART_ADD_ENTRY_SUCCESS).pipe(
      map(() =>
        createFrom(Ga4GgCartAddEntrySuccessEvent, {
          ecommerce: null,
        })
      )
    );

    this.eventService.register(Ga4GgCartAddEntrySuccessEvent, ga4GgCartAddEntrySuccessCleanUpEventSource);

    const ga4GgCartAddEntrySuccessEventSource = this.getAction(CartActions.CART_ADD_ENTRY_SUCCESS).pipe(
      map((successfullyAddedEntry) =>
        createFrom(Ga4GgCartAddEntrySuccessEvent, {
          event: 'add_to_cart',
          visitor_type: this.authStatePersistenceService.isUserLoggedIn() ? 'logged_in' : 'logged-out',
          ecommerce: {
            currency: successfullyAddedEntry.payload.entry.basePrice.currencyIso,
            value: successfullyAddedEntry.payload.entry.basePrice.value * successfullyAddedEntry.payload.quantityAdded,
            items: this.getItemFromPayload(successfullyAddedEntry.payload),
          },
        })
      )
    );

    this.eventService.register(Ga4GgCartAddEntrySuccessEvent, ga4GgCartAddEntrySuccessEventSource);
  }

  protected getAction(actionType: string | string[]): Observable<{ type: string; payload?: any }> {
    return this.actionsSubject.pipe(ofType(...([] as string[]).concat(actionType)));
  }

  private getItemFromPayload(payload) {
    const items: {
      item_id?: string;
      item_name?: string;
      price?: number;
      quantity?: number;
      item_list_name?: string;
    }[] = [];

    const item = {
      item_id: payload.productCode,
      item_name: payload.entry.product.modelMark,
      price: payload.entry.basePrice.value,
      quantity: payload.quantityAdded,
      item_list_name: 'Product single page',
    };

    payload.entry.product.categoryHierarchy?.forEach((category, index) => {
      item['item_category' + (index.toString() !== '0' ? (index + 1).toString() : '')] = category.name;
    });

    Object.keys(item).forEach((key) => (item[key] === undefined ? delete item[key] : {}));

    items.push(item);

    return items;
  }
}
